import useSWR from "swr";
import axios from "axios";

function useLabourer({ shouldFetch = true, userId }) {
  return useSWR(shouldFetch ? [`${process.env.REACT_APP_API_URL}/labourers/by-user-id/${userId}`] : null, async ([url]) => {
    const { data: labourer } = await axios.get(url);

    return { labourer };
  });
}

export default useLabourer;
